// extracted by mini-css-extract-plugin
export default {"container":"bq-z","ratingLayout":"cq-z","ratingLabel":"dq-z","nonInteractiveRatingLabel":"eq-z"};